import { Image } from 'antd';
import { StyledTextPage } from './TextPage.styled';
import AudioPlayPauseButton from '../../components/AudioPlayPauseButton/AudioPlayPauseButton';
import useTextPage from './useTextPage.hook';
import TextWithTranslation from '../../components/TextWithTranslations/TextWithTranslations';

export default function TextPage({ page, folder, activityActions, editing }) {
  useTextPage({ page, activityActions });
  const cloudFolder = `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${folder}`;
  const audio = page.data.audio || `audios/${page.id}.mp3`;
  const audioSrc = `${cloudFolder}/${audio}`;
  const img = page.data.img || `imgs/${page.id}.webp`;
  const imgSrc = `${cloudFolder}/${img}`;
  const hasImg = page.data.hasImg ?? true;

  return (
    <StyledTextPage className="page">
      <div className="wrapper">
        <div className="text-with-audio">
          <TextWithTranslation
            className="text"
            text={page.data.text}
            translations={page.data.translations}
          />
          <AudioPlayPauseButton
            size="large"
            src={audioSrc}
            className="audio-player"
            doPlay={!editing}
          />
        </div>
        {hasImg ? (
          <div className="image-wrapper">
            <Image className="image" src={imgSrc} alt="" preview={false} />
          </div>
        ) : (
          <div className="text-backdrop"></div>
        )}
      </div>
    </StyledTextPage>
  );
}
